import type { ConnectorPropertiesSchema } from "shared-ui";

export type OnlineSalesBannerState =
  | { variant: "critical"; messageKey: "blockedSingle"; platformName: string }
  | { variant: "info"; messageKey: "sameConnectorCovered"; platformName: string }
  | { variant: "info"; messageKey: "otherConnectorCovered"; platformName: string }
  | { variant: "info"; messageKey: "multiplePlatforms" }
  | null;

export function getOnlineSalesBannerState(connectors: ConnectorPropertiesSchema[]): OnlineSalesBannerState {
  const disconnectedConnectors = connectors.filter((connector) =>
    connector.connections.some((connection) => !connection.isConnected)
  );

  if (disconnectedConnectors.length === 0) {
    return null;
  }

  const hasAnyActiveConnection = connectors.some((connector) =>
    connector.connections.some((connection) => connection.isConnected)
  );

  if (disconnectedConnectors.length > 1) {
    return { variant: "info", messageKey: "multiplePlatforms" };
  }

  const [onlyDisconnectedConnector] = disconnectedConnectors;
  const sameConnectorHasActiveConnection = onlyDisconnectedConnector.connections.some(
    (connection) => connection.isConnected
  );

  if (sameConnectorHasActiveConnection) {
    return { variant: "info", messageKey: "sameConnectorCovered", platformName: onlyDisconnectedConnector.name };
  }

  if (hasAnyActiveConnection) {
    return { variant: "info", messageKey: "otherConnectorCovered", platformName: onlyDisconnectedConnector.name };
  }

  return { variant: "critical", messageKey: "blockedSingle", platformName: onlyDisconnectedConnector.name };
}
